import { Component, OnInit, effect, inject } from '@angular/core';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';

@Component({
  selector: 'taly-trusted-parterns',
  templateUrl: './trusted-parterns.component.html',
  styleUrls: ['./trusted-parterns.component.scss']
})
export class TrustedParternsComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);

  partnersItems: any = [];
  responsiveOptions: any[];
  textDirection: string;
  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();

    })
  }
  ngOnInit(): void {
    this.setDataItem()
    this.responsiveOptions = [
      // {
      //     breakpoint: '1199px',
      //     numVisible: 1,
      //     numScroll: 1
      // },
      // {
      //     breakpoint: '991px',
      //     numVisible: 2,
      //     numScroll: 1
      // },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1
      }
    ];

  }
  setDataItem() {
    this.partnersItems = [
      {
        imgUrl: "assets/images/logo-partners-6.svg"
      },
      {
        imgUrl: "assets/images/logo-partners-1.svg"
      },
      {
        imgUrl: "assets/images/logo-partners-2.svg"
      },
      {
        imgUrl: "assets/images/logo-partners-3.svg"
      },
      {
        imgUrl: "assets/images/logo-partners-4.svg"
      },
      {
        imgUrl: "assets/images/logo-partners-5.svg"
      },

    ]
  }
}
